module.exports = __webpack_public_path__ + "img/vedran.d093fd16.jpg";